import { ComponentPropsWithRef, forwardRef } from 'react';

import clsx from 'clsx';

import styles from './invalidMessage.module.css';

export type InvalidMessageProps = ComponentPropsWithRef<'div'>;

export const InvalidMessage = forwardRef<HTMLDivElement, InvalidMessageProps>(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={clsx(styles.root, className)}
		aria-live="polite"
		role="status"
		{...props}
	/>
));
